import React from "react";
import "./starsRating.css";

const StarsRating = ({ node }) => {
  const { rating, stars, ctaLink } = node;
  let starsSrcImg = "";
  switch (stars) {
    case "3":
      starsSrcImg = "/rating/3_star.png";
      break;
    case "3.5":
      starsSrcImg = "/rating/3_and_half_star.png";
      break;
    case "4.5":
      starsSrcImg = "/rating/4_and_half.png";
      break;
    case "5":
      starsSrcImg = "/rating/5_star.png";
      break;
    default:
      starsSrcImg = "/rating/4_star.png";
  }
  return (
    <div>
      {rating ? (
        <a href={ctaLink} className="ctaLink">
          <img src={starsSrcImg} className="ratingImg" />
          <span className="ratingText">{rating} ratings</span>
        </a>
      ) : (
        ""
      )}
    </div>
  );
};

export default StarsRating;
